<template>
  <a-modal v-model:open="visible" title="Complete Campaign" :width="720" :footer="null" @cancel="handleCancel">
    <a-form layout="vertical" ref="formRef" :model="form" :rules="rules" class="complete-modal">
      <a-form-item label="Publish Comments" name="publishComments" required>
        <a-textarea v-model:value="form.publishComments" :disabled="disabled" placeholder="Enter publish comments"
          :rows="4" />
      </a-form-item>

      <a-form-item label="Publish URL" name="publishUrl">
        <a-input v-model:value="form.publishUrl" :disabled="disabled" placeholder="Enter publish URL" />
      </a-form-item>

      <a-form-item label="Publish Date" name="publishDate" required>
        <a-date-picker v-model:value="form.publishDate" :disabled="disabled" style="width: 100%"
          placeholder="Select publish date" />
      </a-form-item>

      <a-form-item label="End Date" name="endDate">
        <a-date-picker v-model:value="form.endDate" style="width: 100%" placeholder="Select end date" />
      </a-form-item>

      <a-form-item label="Impressions" name="impressions">
        <a-input-number v-model:value="form.impressions" placeholder="Enter impressions" style="width: 100%" :min="0" />
      </a-form-item>

      <a-form-item label="Clicks" name="clicks">
        <a-input-number v-model:value="form.clicks" placeholder="Enter clicks" style="width: 100%" :min="0" />
      </a-form-item>

      <a-form-item name="upload">
        <template #label>
          <div class="upload-label">
            <div class="upload-label-text">
              Upload Screentshots
            </div>
            <div class="upload-label-small">
              (Available file format: .png、.gif、.jpg、.jpeg ; Max file size: 10Mb)
            </div>
          </div>

        </template>
        <div class="upload-container">
          <a-upload accept=".jpg,.png,.jpeg,.gif,image/jpeg,image/png,image/jpg,image/gif"
            v-model:fileList="form.upload" name="logo" max-count="10" :custom-request="customUpload" list-type="picture"
            @remove="handleRemove" :before-upload="beforeUpload" @change="handleUploadChange" :show-upload-list="true">
            <artmisads-select-button>
              Upload
            </artmisads-select-button>
          </a-upload>

        </div>
      </a-form-item>

      <a-form-item :wrapper-col="{ offset: 6, span: 18 }" class="modal-footer">
        <a-button type="primary" @click="handleSubmit" :loading="loading">Submit</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref } from 'vue'
import { message } from 'ant-design-vue'
import adminApi from '~/server/seller/admin'
import { publisherCampaignsApi } from '@/server'
import dayjs from 'dayjs'
import { setTime } from '~/utils'

const emit = defineEmits(['submit'])

const visible = ref(false)
const loading = ref(false)
const formRef = ref(null)
const uploadImageUrl = ref('')
const form = ref({
  publishComments: '',
  publishUrl: '',
  publishDate: '',
  endDate: '',
  impressions: null,
  clicks: null,

  upload: []
})
const disabled = ref(false)
const exampleFiles = ref([

])
// 表单验证规则
const rules = {
  publishComments: [
    { required: true, message: 'Please enter publish comments', trigger: 'blur' },

  ],
  publishDate: [
    { required: true, message: 'Please select publish date', trigger: 'change' }
  ],
  publishUrl: [
    { type: 'url', message: 'Please enter a valid URL', trigger: 'blur' }
  ],
  impressions: [
    { type: 'number', min: 0, message: 'Impressions must be a positive number', trigger: 'blur' }
  ],
  clicks: [
    { type: 'number', min: 0, message: 'Clicks must be a positive number', trigger: 'blur' }
  ]
}
// const setTime = (time) => {
//   if(!time) return '--'
//   if (Array.isArray(time)) {
//     return `${time[0]}-${time[1]}-${time[2]}`
//   } else {
//     return time
//   }
// }
const campaignId = ref()
const show = (id, data) => {
  campaignId.value = id
  visible.value = true
  disabled.value = false
  form.value = {
    publishComments: '',
    publishUrl: '',
    publishDate: '',
    endDate: '',
    impressions: null,
    clicks: null,
    upload: []
  }
  exampleFiles.value = []
  if (data) {

    form.value.publishComments = data.publishComments
    form.value.publishUrl = data.publishUrl
    form.value.impressions = data.impressions
    form.value.clicks = data.clicks
    form.value.publishDate = dayjs(setTime(data.publishDate,false))
    form.value.endDate = dayjs(setTime(data.endDate,false))
    disabled.value = true
    form.value.upload = data.completionScreenshots.map(item => {
      return {
        url: item.url,
        name: item.originalFileName
      }
    })
    exampleFiles.value = data.completionScreenshots
  }
}

const hide = () => {
  visible.value = false
  resetForm()
}

const handleCancel = () => {
  hide()
}
// 处理上传状态变化
const handleUploadChange = (info) => {
  const { file, fileList } = info
  // if (info.file.status === 'uploading') {
  //   spinning.value = true;
  //   return
  // }

  if (file.status === 'done') {
    getBase64(file.originFileObj, (base64Url) => {
      uploadImageUrl.value = base64Url
    })
  }
  // 如果上传失败，清除错误状态
  if (file.status === 'error') {
    message.error('Upload failed. Please try again.')
    // 自动清除失败的文件
    setTimeout(() => {
      form.value.upload = fileList.filter(item => item.status !== 'error')
    }, 2000)
  }

}
function getBase64 (img, callback) {
  const reader = new FileReader()

  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
// 文件上传前的验证
const beforeUpload = (file) => {
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif'
  ]

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

  const isValidType = allowedTypes.includes(file.type)
  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )

  if (!isValidType && !isValidExtension) {
    message.error('Only  jpg, png, jpeg, gif files are supported') // 英文  只支持上传 zip、jpg、png、jpeg、pdf、rar 格式的文件
    return false
  }

  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('File size cannot exceed 10MB!')
    return false
  }

  return true
}
const handleRemove = (file) => {
  // console.log(file, 'file')
  exampleFiles.value = exampleFiles.value.filter(item => item.originalFileName !== file.name)
  // console.log(exampleFiles.value,'exampleFiles.value')
}
const customUpload = (options) => {
  const { file, onSuccess, onError, onProgress } = options

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )
  loading.value = true
  if (isValidExtension) {
    const data = {}

    if (file) {
      data.file = file
    } else {
      data.url = encodeURIComponent(uploadImageUrl.value)
    }
    // 模拟上传进度
    adminApi.uploadImg(data).then((res) => {

      onSuccess({
        url: URL.createObjectURL(file),
        name: file.name,
        status: 'done'
      })
      exampleFiles.value.push({
        originalFileName: file.name,
        url: res.data.url
      })
    }).catch(e => {
      console.log(e)
    }).finally(() => {
      loading.value = false
    })
  }
}
const handleSubmit = async () => {
  try {
    // 使用表单验证
    await formRef.value.validate()

    loading.value = true

    // 转换日期为时间戳
    const formData = {
      ...form.value,
      publishDate: form.value.publishDate ? form.value.publishDate.valueOf() : null,
      endDate: form.value.endDate ? form.value.endDate.valueOf() : null,
      completionScreenshots: exampleFiles.value,
      campaignId: campaignId.value
    }
    publisherCampaignsApi.payCampaign(formData).then(res => {
      if (res.success) {
        message.success('Complete Success')
        hide()
        emit('submit', res.data)
      }
      else {
        message.error(res.error)

      }

    })
  } catch (error) {
    console.log('Form validation failed:', error)
  } finally {
    loading.value = false
  }
}



const resetForm = () => {
  formRef.value?.resetFields()
  form.value = {
    publishComments: '',
    publishUrl: '',
    publishDate: '',
    endDate: '',
    impressions: null,
    clicks: null,

    upload: []
  }
}

// 暴露方法给父组件
defineExpose({
  show,
  hide
})
</script>

<style scoped lang="less">

:deep(label){
  font-weight: bolder;
}
.upload-label-small{
  font-size: 10px;
  color: var(--dark-2);
  margin-left: 8px;
  font-weight: 400;
}
.complete-modal {
  .modal-footer {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>
